import { Injectable } from "@angular/core";
import { PrelevementAir } from "src/app/domain/Air/prelevement-air";
import { PrelevementQualifSalle } from "src/app/domain/Qualif/prelevement-qualif-salle";
import { Reprise } from "src/app/domain/Qualif/reprise";
import { Soufflage } from "src/app/domain/Qualif/soufflage";
import { ZoneCompare } from "src/app/domain/Qualif/zone-compare";
import { PrelevementSurface } from "src/app/domain/Surface/prelevement-surface";
import { Flacon } from "src/app/domain/flacon";
import { mapper } from "src/app/tools/mapping/mapper";
import { Zone } from '../../domain/zone';

import { db } from "../db";
import { FlaconEntity } from "../flacon.entity";
import { InterventionEntity } from "../intervention.entity";
import { PrelevementAirEntity } from "../prelevement-air.entity";
import { PrelevementQualifSalleEntity } from "../prelevement-qualif-salle.entity";
import { PrelevementSurfaceEntity } from "../prelevement-surface.entity";
import { RepriseEntity } from "../reprise.entity";
import { SoufflageEntity } from "../soufflage.entity";
import { ZoneCompareEntity } from "../zone-compare.entity";
import { ZoneEntity } from "../zone.entity";
import { FlaconRepository } from "./flacon.repository";
import { PrelevementAirRepository } from "./prelevement-air.repository";
import { PrelevementSurfaceRepository } from "./prelevement-surface.repository";
import { QualifSalleRepository } from "./qualif-salle.repository";
import { RepriseRepository } from "./reprise.repository";
import { SoufflageRepository } from "./soufflage.repository";
import { ZoneCompareRepository } from "./zone-compare.repository";

@Injectable({
    providedIn: 'root',
})
export class ZoneRepository {
    constructor(private prelevementAirRepository: PrelevementAirRepository,
        private prelevementSurfaceRepository: PrelevementSurfaceRepository,
        // private interventionRepository: InterventionRepository,
        private flaconRepository: FlaconRepository,
        private repriseRepository: RepriseRepository,
        private soufflageRepository: SoufflageRepository,
        private qualifSalleRepository: QualifSalleRepository,
        private zoneCompareRepository: ZoneCompareRepository,

    ) { }

    async changeZoneTaskStatus(zone: Zone) {
        const ze = await this.getZoneEntityByCode(zone.Code)
        if (!ze || !ze.Id) {
            return;
        }
        await db.zones.update(ze.Id, {
            TaskStatus: zone.TaskStatus
        });
        return true;
    }

    async getZoneByCodeWithChildren(code: string) {
        return await db.zones.where('Code').equals(code).first(async ze => {
            const z = mapper.map(ze, ZoneEntity, Zone);

            if (ze?.PrelevementAirIds) {
                for (let i = 0; i < ze.PrelevementAirIds.length; i++) {
                    z.PrelevementAirList.push(await this.prelevementAirRepository.getPrelevementAirById(ze.PrelevementAirIds[i]));
                }
            }
            if (ze?.PrelevementSurfaceIds) {
                for (let i = 0; i < ze.PrelevementSurfaceIds.length; i++) {
                    z.PrelevementSurfaceList.push(await this.prelevementSurfaceRepository.getPrelevementSurfaceById(ze.PrelevementSurfaceIds[i]));
                }
            }

            if (ze?.PrelevementQualifSalleId) {
                z.PrelevementQualifSalle = await this.qualifSalleRepository.getQualifSalleById(ze.PrelevementQualifSalleId)
            }

            return z;
        });
    }

    async getZoneEntityByCode(code: string) {
        return await db.zones.where('Code').equals(code).first(async me => {
            return me;
        });
    }

    async getZoneEntityById(id: number) {
        return await db.zones.where('Id').equals(id).first(async ze => {
            return ze;
        });
    }
    async getZoneById(id: number) {
        return await db.zones.where('Id').equals(id).first(async ze => {
            const z = mapper.map(ze, ZoneEntity, Zone);
            if (ze?.PrelevementAirIds) {
                for (let i = 0; i < ze.PrelevementAirIds.length; i++) {
                    z.PrelevementAirList.push(await this.prelevementAirRepository.getPrelevementAirById(ze.PrelevementAirIds[i]));
                }
            }
            if (ze?.PrelevementSurfaceIds) {
                for (let i = 0; i < ze.PrelevementSurfaceIds.length; i++) {
                    z.PrelevementSurfaceList.push(await this.prelevementSurfaceRepository.getPrelevementSurfaceById(ze.PrelevementSurfaceIds[i]));
                }
            }

            if (ze?.PrelevementQualifSalleId) {
                z.PrelevementQualifSalle = await this.qualifSalleRepository.getQualifSalleById(ze?.PrelevementQualifSalleId);
            }
            return z;
        });
    }

    async attachZone(zone: Zone, interventionEntity: InterventionEntity) {
        let zoneId: number;
        const ze = mapper.map(zone, Zone, ZoneEntity);

        // const ie = await this.interventionRepository.getInterventionEntityById(interventionId);
        ze.Id = await db.zones.add(ze);
        interventionEntity.ZoneIds = interventionEntity?.ZoneIds ? [...interventionEntity.ZoneIds, ze.Id] : [ze.Id]
        await db.interventions.update(interventionEntity.Id!, {
            ZoneIds: interventionEntity?.ZoneIds
        });

        if (zone.PrelevementAirList?.length > 0) {
            for (let i = 0; i < zone.PrelevementAirList.length; i++) {
                await this.prelevementAirRepository.attachPrelevementAir(zone.PrelevementAirList[i], ze);
            }
        }

        if (zone.PrelevementSurfaceList?.length > 0) {
            for (let i = 0; i < zone.PrelevementSurfaceList.length; i++) {
                await this.prelevementSurfaceRepository.attachPrelevementSurface(zone.PrelevementSurfaceList[i], ze);
            }
        }

        if (zone.PrelevementQualifSalle) {
            await this.qualifSalleRepository.attachQualifSalle(zone.PrelevementQualifSalle, ze);
        }

        return ze.Id;
    }

    async updateZone(zone: Zone) {
        let zme = await this.getZoneEntityByCode(zone.Code);
        if (!zme || !zme.Id) {
            return false;
        }

        if (zme.PrelevementAirIds?.length > 0) {
            for (let i = 0; i < zme.PrelevementAirIds?.length; i++) {
                let pae = await this.prelevementAirRepository.getPrelevementAirEntityById(zme.PrelevementAirIds[i]);
                if (pae) {
                    mapper.mutate(zone.PrelevementAirList[i], pae, PrelevementAir, PrelevementAirEntity);
                    await db.prelevementAirs.update(zme.PrelevementAirIds[i], pae);

                    // #################################################################################

                    // let ae = await this.appareilRepository.getAppareilEntityById(pae.AppareilId!)
                    // if (ae) {
                    //     mapper.mutate(zone.PrelevementAirList[i].Biocollecteur, ae, Appareil, AppareilEntity)
                    //     await db.appareils.update(ae.Id!, ae);
                    // }

                    // #################################################################################

                    for (let j = 0; j < zone.PrelevementAirList[i].Prelevement.FlaconList.length; j++) {
                        let fe = await this.flaconRepository.getFlaconEntityByCode(zone.PrelevementAirList[i].Prelevement.FlaconList[j].Code);
                        if (fe && fe.Id) {
                            mapper.mutate(zone.PrelevementAirList[i].Prelevement.FlaconList[j], fe, Flacon, FlaconEntity);
                            await db.flacons.update(fe.Id, zone.PrelevementAirList[i].Prelevement.FlaconList[j]);
                        }
                    }
                }
            }
        }

        if (zme.PrelevementSurfaceIds?.length > 0) {
            for (let i = 0; i < zme.PrelevementSurfaceIds?.length; i++) {
                let pae = await this.prelevementSurfaceRepository.getPrelevementSurfaceEntityById(zme.PrelevementSurfaceIds[i]);
                if (pae) {
                    mapper.mutate(zone.PrelevementSurfaceList[i], pae, PrelevementSurface, PrelevementSurfaceEntity);
                    await db.prelevementSurfaces.update(zme.PrelevementSurfaceIds[i], pae);

                    for (let j = 0; j < zone.PrelevementSurfaceList[i].Prelevement.FlaconList.length; j++) {
                        let fe = await this.flaconRepository.getFlaconEntityByCode(zone.PrelevementSurfaceList[i].Prelevement.FlaconList[j].Code);
                        if (fe && fe.Id) {
                            mapper.mutate(zone.PrelevementSurfaceList[i].Prelevement.FlaconList[j], fe, Flacon, FlaconEntity);
                            await db.flacons.update(fe.Id, zone.PrelevementSurfaceList[i].Prelevement.FlaconList[j]);
                        }
                    }
                }
            }
        }

        if (zme.PrelevementQualifSalleId && zone.PrelevementQualifSalle) {
            let qse = await this.qualifSalleRepository.getQualifSalleEntityById(zme.PrelevementQualifSalleId);
            if (qse) {
                mapper.mutate(zone.PrelevementQualifSalle, qse, PrelevementQualifSalle, PrelevementQualifSalleEntity);
                await db.prelevementQualifSalles.update(zme.PrelevementQualifSalleId, zone.PrelevementQualifSalle);

            }
            // for (let j = 0; j < zone.PrelevementQualifSalle.AppareilQualifList.length; j++) {
            //     let ae = await this.appareilRepository.getAppareilEntityByCode(zone.PrelevementQualifSalle.AppareilQualifList[j].Code);
            //     if (ae && ae.Id) {
            //         mapper.mutate(zone.PrelevementQualifSalle.AppareilQualifList[j], ae, Appareil, AppareilEntity);
            //         await db.appareils.update(ae.Id, zone.PrelevementQualifSalle.AppareilQualifList[j]);
            //     }
            // }

            for (let j = 0; j < zone.PrelevementQualifSalle.SoufflageList.length; j++) {
                let ae = await this.soufflageRepository.getSoufflageEntityByCode(zone.PrelevementQualifSalle.SoufflageList[j].Code);
                if (ae && ae.Id) {
                    mapper.mutate(zone.PrelevementQualifSalle.SoufflageList[j], ae, Soufflage, SoufflageEntity);
                    await db.soufflages.update(ae.Id, zone.PrelevementQualifSalle.SoufflageList[j]);
                }
            }

            for (let j = 0; j < zone.PrelevementQualifSalle.RepriseList.length; j++) {
                let ae = await this.repriseRepository.getRepriseEntityByCode(zone.PrelevementQualifSalle.RepriseList[j].Code);
                if (ae && ae.Id) {
                    mapper.mutate(zone.PrelevementQualifSalle.RepriseList[j], ae, Reprise, RepriseEntity);
                    await db.reprises.update(ae.Id, zone.PrelevementQualifSalle.RepriseList[j]);
                }
            }

            for (let j = 0; j < zone.PrelevementQualifSalle.ZoneAComparerList.length; j++) {
                let ae = await this.zoneCompareRepository.getZoneCompareEntityByCode(zone.PrelevementQualifSalle.ZoneAComparerList[j].Code);
                if (ae && ae.Id) {
                    mapper.mutate(zone.PrelevementQualifSalle.ZoneAComparerList[j], ae, ZoneCompare, ZoneCompareEntity);
                    await db.zoneCompares.update(ae.Id, zone.PrelevementQualifSalle.ZoneAComparerList[j]);
                }
            }
        }

        mapper.mutate(zone, zme, Zone, ZoneEntity);
        await db.zones.update(zme.Id, zme);

        return true;
    }
}